(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["hiplot"] = factory(require("react"));
	else
		root["hiplot"] = factory(root["React"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__787__) {
return 